export default __webpack_public_path__ + "2414478eadf416b059af1ed9d4c9b357.png";